import { useState } from 'react';
import { toast } from 'sonner';
import { ExternalLink } from 'lucide-react';
import { Button } from '../ui/button';
import { API_URL } from '../../lib/api';
import { savApi } from './savApi';
import { SavJustifs } from './SavJustifs';
import { errMsg } from '../invoice/api';

// Justificatifs d'un dossier : consultation, ajout de fichiers ou d'une facture déjà enregistrée (aucune seconde dépense)
export function SavDossierJustifs({ dossier, onChanged }) {
    const [files, setFiles] = useState([]);
    const [invoices, setInvoices] = useState([]);
    const n = dossier.nb_justificatifs || 0;
    const save = async () => {
        try { await savApi.attach(dossier.id, { justificatif_ids: files.map(f => f.id), facture_ids: invoices.map(i => i.id) }); toast.success('Justificatifs joints'); setFiles([]); setInvoices([]); onChanged?.(); }
        catch (e) { toast.error(errMsg(e)); }
    };
    return (
        <div className="space-y-2 border-t border-gray-100 pt-3" data-testid="sav-dossier-justifs">
            <div className="flex flex-wrap gap-2">
                {Array.from({ length: n }).map((_, i) => (
                    <a key={i} href={`${API_URL}/api/sav-retenues/${dossier.id}/justificatif?n=${i}`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-[12px] text-[#6366F1] underline" data-testid={`sav-dossier-justif-link-${i}`}>
                        <ExternalLink className="w-3 h-3" />Justificatif {i + 1}
                    </a>
                ))}
                {!n && <span className="text-[12px] text-gray-400">Aucun justificatif</span>}
            </div>
            <SavJustifs files={files} setFiles={setFiles} invoices={invoices} setInvoices={setInvoices} />
            {(files.length > 0 || invoices.length > 0) && <Button size="sm" onClick={save} data-testid="sav-dossier-justifs-save">Joindre au dossier</Button>}
        </div>
    );
}
